//设置rem函数
function setRem() {
  const htmlWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName("html")[0];
  htmlDom.style.fontSize = htmlWidth / 19.2 + "px";
}

//初始化
setRem();
//改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
